import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retry: false,
    },
  },
});

export enum QueryKeys {
  TEAM_PERMISSIONS_HISTORY = 'TEAM_PERMISSIONS_HISTORY',
  TUNNELS = 'TUNNELS',
  TUNNEL_METRICS = 'TUNNEL_METRICS',
  TEAM_FEATURES = 'TEAM_FEATURES',
  PRICES = 'PRICES',
  MY_TEAMS = 'MY_TEAMS',
  HOST_GROUPS = 'HOST_GROUPS',
}
